import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL_SANDBOX,
  LP_SC_PAYMENT,
} from '../../../Constants/Config';

const initialState = {
  loading: false,
  LpscPaymentData: {},
  successMessage: '',
  error: '',
  requestKey: null,
  activeRequestKey: null,
  activeRequestId: null,
};

export const createLpscPaymentRequestKey = (data) => {
  const customerId = String(data?.customer_id ?? '').trim();
  const merchantId = String(data?.merchant_id ?? '').trim().toUpperCase();
  const groupId = String(data?.group_id ?? '').trim();

  return customerId && merchantId
    ? JSON.stringify([customerId, merchantId, groupId])
    : '';
};

export const fetchLpscPaymentData = createAsyncThunk(
  'loyaltyPoint/fetchLpscPaymentData.',
  async (data) => {
    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + LP_SC_PAYMENT,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      return response.data.status === 200 ? response.data.result : [];
    } catch (error) {
      throw new Error(
        error?.response?.data?.message ||
          error?.message ||
          'Unable to retrieve loyalty data',
      );
    }
  },
);

const lpscPaymentSlice = createSlice({
  name: 'loyaltyPoint',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchLpscPaymentData.pending, (state, action) => {
      const requestKey = createLpscPaymentRequestKey(action.meta?.arg);
      if (state.requestKey !== requestKey) {
        state.LpscPaymentData = {};
        state.requestKey = null;
      }
      state.loading = true;
      state.error = '';
      state.activeRequestKey = requestKey;
      state.activeRequestId = action.meta?.requestId || null;
    });
    builder.addCase(fetchLpscPaymentData.fulfilled, (state, action) => {
      const requestKey = createLpscPaymentRequestKey(action.meta?.arg);
      if (
        state.activeRequestId !== action.meta?.requestId ||
        state.activeRequestKey !== requestKey
      ) {
        return;
      }

      state.loading = false;
      state.LpscPaymentData = action.payload || {};
      state.requestKey = requestKey || null;
      state.activeRequestKey = null;
      state.activeRequestId = null;
      state.error = '';
    });
    builder.addCase(fetchLpscPaymentData.rejected, (state, action) => {
      const requestKey = createLpscPaymentRequestKey(action.meta?.arg);
      if (
        state.activeRequestId !== action.meta?.requestId ||
        state.activeRequestKey !== requestKey
      ) {
        return;
      }

      state.loading = false;
      state.LpscPaymentData = [];
      state.requestKey = null;
      state.activeRequestKey = null;
      state.activeRequestId = null;
      state.error = action.error?.message || 'Unable to retrieve loyalty data';
    });
  },
});

export default lpscPaymentSlice.reducer;
